import type { ComponentProps } from 'lib/component-props';
import { TextField, RichTextField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { DrugCoverageTableGroup } from './DrugCoverageTables.Type';
import { PlanYear } from './PlanYear.Type';

export type PlanResponse = {
  id: string;
  planName: TextField;
  planDescription: RichTextField;
  contract: TextField;
  pbp: TextField;
  groupId: TextField;
  cavulusPlanName: TextField;
  starRating: {
    targetItem: {
      value: { value: string };
    };
  };
  additionalBenefits: {
    targetItem: {
      caption: { value: string };
      value: { value: string };
    };
  };
  documents: { targetItems: DocumentTargetItem[] };
  planDetailEntries: { targetItems: PlanDetailEntry[] };
  prescriptionDrugTables: { targetId: string };
};

export type DocumentTargetItem = {
  documentTitle: { value: string };
  documentLink: { jsonValue: LinkField };
  documentLanguage: { targetItem: Language };
  updatedDate: { value: string };
};

export type Language = {
  lastUpdatedDateLabel: { value: string };
  languageAttribute: { value: string };
  value: { value: string };
};

export type PlanDetailEntry = {
  id: string;
  description: TextField;
  entryRow: PlanDetailRowParent;
};

export type PlanDetailRowParent = {
  id: string;
  label: TextField;
  entryTable: PlanDetailGroupParent;
};

export type PlanDetailGroupParent = {
  id: string;
  caption: TextField;
};

export type PlanDetailGroup = {
  id: string;
  caption: string;
  planDetailRows: Array<PlanDetailRow>;
};

export type PlanDetailRow = {
  id: string;
  label: string;
  tooltip: string;
  planEntries: Array<PlanEntry>;
};

export type PlanEntry = {
  id: string;
  name: string;
  value: string;
};

export type PlanTypes = {
  id: string;
  name: string;
  fields: PlanTypeFields;
};

export type PlanTypeFields = {
  id: string;
  planDetailPage: {
    url?: string;
  };
  planSearchPage: {
    url: string;
  };
};

export type PlanComparisonTableFields = {
  planType: PlanTypes;
  planDetailGroupLayout: Array<PlanDetailGroup>;
  rowNotCoveredText: TextField;
  rxTableNotCoveredText: TextField;
  rxRowNotCoveredText: TextField;
  showRxDrugCoverageTable: {
    value: boolean;
  };
  drugCoverageGroups: Array<DrugCoverageTableGroup>;
  planYears: PlanYear[];
};

export type PlanComparisonTableProps = ComponentProps & {
  fields: PlanComparisonTableFields;
};
